import styled from "styled-components";

export const PaginationWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  margin: 32px 0;
`;

export const PaginationButton = styled.button`
  background: none;
  border: none;
  color: #232336;
  font-weight: 600;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;

  &:disabled {
    color: #888;
    cursor: default;
  }

  &.active {
    background: var(--color-purple);
    color: #fff;
  }
`;

export const PaginationTextButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.disabled ? "var(--color-gray-500)" : "var(--color-black)"};
  font-weight: 600;
  font-size: var(--text-size-xsm);

  @media (max-width: 1104px) {
    font-size: var(--text-size-xs);
  }
`;